<div class="text-center">
    <div class="relative">
        <ng-select #notificationTypeSelect class="custom-ng-select" [items]="notificationTypeList"
            bindLabel="status_selected" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
            [loading]="notificationTypeLoading" [typeahead]="notificationTypeInput$" typeToSearchText=""
            [virtualScroll]="true" [(ngModel)]="notificationType" [searchable]="false"></ng-select>
        <i class="fa fa-search" style="right: 17px !important; top: 15px !important;"></i>
    </div>
</div>